import type { UseFetchOptions } from 'nuxt/app'
import { hash } from 'ohash'

export const useApi = () => {
  const config = useRuntimeConfig()

  // 不再使用静默 fallback，避免生产环境因为环境变量未注入而错误地回退到预生产 API
  const baseURL = (config.public.apiBase as string | undefined) || ''
  if (!baseURL) {
    // eslint-disable-next-line no-console
    console.error(
      '[useApi] runtimeConfig.public.apiBase 为空，请检查构建时是否注入了 NUXT_API_BASE',
    )
  }

  const apiFetch = <T>(url: string, options?: UseFetchOptions<T, any>) => {
    // 如果用户明确设置了 server 选项，则使用用户的设置
    // 否则，在 SSR 模式下允许服务器端请求，在客户端渲染模式下只在客户端执行
    const defaultServer =
      options?.server !== undefined ? options.server : undefined // 不设置，让 useFetch 使用默认行为（SSR 模式下会在服务器端执行）

    // 生成唯一 key，包含 url 和 query 参数，防止在同一个页面调用多次导致的数据覆盖问题
    const fetchKey =
      options?.key || hash([url, unref(options?.query), options?.method])

    return useFetch<T>(url, {
      key: fetchKey,
      baseURL,
      // 禁用 Nuxt 默认的 payload 缓存机制，确保每次访问都会真实发起请求
      getCachedData() {
        return null
      },
      ...options,
      // 只在明确设置时才覆盖 server 选项
      ...(defaultServer !== undefined && { server: defaultServer }),
      // 添加默认的错误处理
      onRequest({ options }: any) {
        // 可以在这里添加请求拦截器，比如添加 token
        // options.headers = options.headers || {}
        // options.headers.Authorization = `Bearer ${token}`
      },
      onRequestError({ error }: any) {
        // eslint-disable-next-line no-console
        console.error('请求错误:', error)
      },
      onResponse({ response }: any) {
        // 可以在这里处理响应
        // console.log('响应:', response)
      },
      onResponseError({ response }: any) {
        // eslint-disable-next-line no-console
        console.error(
          '响应错误:',
          response.status,
          response.statusText,
          response._data,
        )
      },
    } as any)
  }

  return {
    apiFetch,
  }
}
